export default __webpack_public_path__ + "images/f0056111f4b77155d09a3c5c5a122b85.png";